import { getContent } from '@/utils/helper';

import { Cta } from './Cta';

function CtfCta({
  entries,
  field,
  invert,
  noWrap,
  hideIcon,
  onClick,
  size,
  className,
  wrapperClassName,
  animation,
}) {
  if (!field) {
    return null;
  }

  const cta = getContent(field.sys?.id, entries);
  if (!cta) {
    return null;
  }

  const {
    name,
    link,
    page: pageField,
    icon,
    style: type,
    hasIconBorder,
  } = cta.fields || {};
  const page = pageField
    ? getContent(pageField.sys.id, entries)?.fields?.slug
    : null;

  return (
    <Cta
      iconProps={{
        hasIconBorder,
        height: 15,
        hideIcon,
        name: icon,
        width: 15,
      }}
      buttonProps={{
        name,
        type,
        style: `${className} ${noWrap ? 'w-max' : 'w-fit'}`,
        wrapperClassName,
        invert,
        size,
      }}
      linkProps={{
        url: link,
        page,
      }}
      onClick={onClick}
      animation={animation}
    />
  );
}

export default CtfCta;
